/* Google Places address autocomplete for the account application form.
   Uses the Places API (New) data API so the dropdown matches the site design. */
(function () {
  'use strict';
  var KEY = window.JBT_MAPS_KEY;
  var wraps = document.querySelectorAll('[data-address-autocomplete]');
  if (!KEY || !wraps.length) return;

  // Google's recommended bootstrap: adds google.maps.importLibrary without blocking the page.
  (function (g) {
    var h, a, k, p = 'The Google Maps JavaScript API', c = 'google', l = 'importLibrary', q = '__ib__', m = document, b = window;
    b = b[c] || (b[c] = {});
    var d = b.maps || (b.maps = {}), r = new Set(), e = new URLSearchParams();
    var u = function () {
      return h || (h = new Promise(function (f, n) {
        a = m.createElement('script');
        e.set('libraries', Array.from(r) + '');
        for (k in g) e.set(k.replace(/[A-Z]/g, function (t) { return '_' + t[0].toLowerCase(); }), g[k]);
        e.set('callback', c + '.maps.' + q);
        a.src = 'https://maps.' + c + 'apis.com/maps/api/js?' + e;
        d[q] = f;
        a.onerror = function () { h = n(Error(p + ' could not load.')); };
        m.head.append(a);
      }));
    };
    if (!d[l]) d[l] = function (f) { var rest = Array.prototype.slice.call(arguments, 1); r.add(f); return u().then(function () { return d[l].apply(null, [f].concat(rest)); }); };
  })({ key: KEY, v: 'weekly' });

  var placesPromise = null;
  function places() {
    if (!placesPromise) placesPromise = google.maps.importLibrary('places');
    return placesPromise;
  }

  function comp(list, type, short) {
    for (var i = 0; i < list.length; i++) {
      if (list[i].types.indexOf(type) !== -1) return short ? list[i].shortText : list[i].longText;
    }
    return '';
  }

  wraps.forEach(function (wrap) {
    var form = wrap.closest('form');
    var input = wrap.querySelector('[data-ac-input]');
    var list = wrap.querySelector('.address-ac__list');
    var city = form.querySelector('[data-ac-city]');
    var postal = form.querySelector('[data-ac-postal]');
    var province = form.querySelector('[data-ac-province]');
    var token = null, timer = null, items = [], active = -1, lastQuery = '';

    function close() {
      list.hidden = true; list.innerHTML = ''; items = []; active = -1;
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
    }

    function highlight(i) {
      var lis = list.querySelectorAll('li');
      lis.forEach(function (li, n) { li.setAttribute('aria-selected', n === i ? 'true' : 'false'); });
      active = i;
      if (lis[i]) { input.setAttribute('aria-activedescendant', lis[i].id); lis[i].scrollIntoView({ block: 'nearest' }); }
    }

    function render(suggestions) {
      list.innerHTML = ''; items = suggestions; active = -1;
      if (!suggestions.length) { close(); return; }
      suggestions.forEach(function (s, i) {
        var p = s.placePrediction;
        var li = document.createElement('li');
        li.id = list.id + '-opt-' + i;
        li.setAttribute('role', 'option');
        var main = document.createElement('strong');
        main.textContent = p.mainText ? p.mainText.text : p.text.text;
        li.appendChild(main);
        if (p.secondaryText && p.secondaryText.text) {
          var sec = document.createElement('span');
          sec.textContent = p.secondaryText.text;
          li.appendChild(sec);
        }
        li.addEventListener('mousedown', function (e) { e.preventDefault(); choose(i); });
        list.appendChild(li);
      });
      var credit = document.createElement('li');
      credit.className = 'address-ac__credit';
      credit.setAttribute('aria-hidden', 'true');
      credit.textContent = 'Powered by Google';
      list.appendChild(credit);
      list.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }

    function search(q) {
      places().then(function (lib) {
        if (!token) token = new lib.AutocompleteSessionToken();
        return lib.AutocompleteSuggestion.fetchAutocompleteSuggestions({
          input: q,
          sessionToken: token,
          includedRegionCodes: ['ca'],
          locationBias: { center: { lat: 43.7764, lng: -79.2318 }, radius: 50000 },
          language: 'en'
        });
      }).then(function (res) {
        if (input.value.trim() !== q) return; // a newer keystroke has arrived
        render((res.suggestions || []).filter(function (s) { return s.placePrediction; }).slice(0, 5));
      }).catch(function (err) {
        console.warn('[address autocomplete]', err);
        close();
      });
    }

    function choose(i) {
      var s = items[i];
      if (!s) return;
      var pred = s.placePrediction;
      input.value = pred.mainText ? pred.mainText.text : pred.text.text;
      close();
      var place = pred.toPlace();
      place.fetchFields({ fields: ['addressComponents', 'formattedAddress'] }).then(function () {
        var c = place.addressComponents || [];
        var street = [comp(c, 'street_number'), comp(c, 'route')].filter(Boolean).join(' ');
        var unit = comp(c, 'subpremise');
        if (street) input.value = unit ? unit + '-' + street : street;
        var town = comp(c, 'locality') || comp(c, 'sublocality') || comp(c, 'postal_town') || comp(c, 'administrative_area_level_3');
        if (town && city) city.value = town;
        var pc = comp(c, 'postal_code');
        if (postal) postal.value = pc || postal.value;
        if (province) province.value = comp(c, 'administrative_area_level_1', true);
        [input, city, postal].forEach(function (el) { if (el) el.dispatchEvent(new Event('change', { bubbles: true })); });
        if (postal && !pc) postal.focus();
      }).catch(function (err) { console.warn('[address autocomplete]', err); });
      token = null; // fetchFields ends the billing session
    }

    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(timer);
      if (q.length < 3) { close(); return; }
      if (q === lastQuery) return;
      timer = setTimeout(function () { lastQuery = q; search(q); }, 220);
    });

    input.addEventListener('keydown', function (e) {
      if (list.hidden) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); highlight(Math.min(active + 1, items.length - 1)); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); highlight(Math.max(active - 1, 0)); }
      else if (e.key === 'Enter' && active > -1) { e.preventDefault(); choose(active); }
      else if (e.key === 'Escape') { close(); }
    });

    input.addEventListener('blur', function () { setTimeout(close, 150); });
    input.addEventListener('focus', function () { places(); }); // warm up the library
  });
})();
